import React, { FunctionComponent, memo, useState } from 'react'
import styles from './Header.module.sass'
import selectStyles from '../../data-components/lists/Select/Select.module.sass'
import listStyles from '../../data-components/lists/List/List.module.sass'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { RootActions, RootState } from '../../../redux/root'
import { Link, NavLink } from 'react-router-dom'
import clsx from 'clsx'
import UserPanel from '../../data-components/elements/UserElement/UserElement'
import Select from '../../data-components/lists/Select/Select'
import { unit } from '../../../utils/utils'
import { Role } from '../../../responses/users'
import NotificationPanel from '../../pages/Page/NotificationPanel/NotificationPanel'
import { userActions } from '../../../redux/global/user/user-actions'
import { ROUTES } from '../../../http/routes'
import { processDate } from '../../../utils/date-utils'
import Popover from '../../etc/Popover'
import TasksPanel from '../../pages/Page/TasksPanel/TasksPanel'
import ChevronDownIcon from 'files/chevron/down.svg'
import AccountIcon from 'files/user/user.svg'
import ExitIcon from 'files/exit.svg'
import ShadowContainer from '../../etc/popover/ShadowContainer/ShadowContainer'
import Ellipsis from '../../etc/Ellipsis/Ellipsis'
import { useQueries } from '../../../utils/hooks/useQueries'
import { getId } from '../../../utils/entity-utils'
import HeaderLogo from './HeaderLogo/HeaderLogo'
import ContactsIcon from 'files/contacts.svg'

interface Props {
    className?: string,
}

const Header: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch<Dispatch<RootActions>>()
    const userData = useSelector((state: RootState) => state.global.user.data)
    const { isMobile, isDesktop } = useQueries()

    const isDevelopment = localStorage.getItem('debug') === '1' || process.env.NODE_ENV === 'development'

    return <div className={clsx(props.className, styles.header, {
        [styles.dev]: isDevelopment,
    })}>
        <NavLink to={ROUTES.ROOT}>
            <span className={styles.logo_wrapper}>
                <span className={styles.logo_svg}>
                    <HeaderLogo/>
                </span>
                <span className={styles.logo_text}>СУП</span>
            </span>
        </NavLink>
        {
            isDevelopment && <div className={styles.devInfo}>
                <Ellipsis className={styles.text}>
                    {process.env.NODE_ENV === 'development' ? 'ЛОКАЛЬНЫЙ ЗАПУСК' : 'ТЕСТОВЫЙ СЕРВЕР'}
                </Ellipsis>
                {
                    isDesktop && <div>Сборка от {processDate(process.env?.BUILD_VERSION)}</div>
                }
                <Link to={ROUTES.INFO}>подробнее...</Link>
            </div>
        }
        {
            isMobile && <Link to={ROUTES.CONTACTS}><ContactsIcon className={ styles.contactIcon} /></Link>
        }
        <TasksPanel className={styles.taskPanel}/>
        <NotificationPanel/>
        <Popover
            reposition={false}
            isOpen={open}
            onClickOutside={() => setOpen(false)}
            positions={['bottom']}
            padding={-8}
            align={'end'}
            content={state => <ShadowContainer state={state} className={styles.popover}>
                {
                    ((userData?.roles.length ?? 0) > 1) && <Select<Role>
                        data={userData?.roles || []}
                        render={role => role.title}
                        selected={unit<Role>(userData?.role)}
                        header={true}
                        toKey={getId}
                        className={styles.list}
                        toClassName={() => styles.menuItem}
                        onClick={role => dispatch(userActions.update.request({ role: role.id }))}
                    />
                }
                <div className={clsx(listStyles.list, selectStyles.select, listStyles.separator, listStyles.interactive)}>
                    <Link
                        className={clsx(listStyles.item, styles.menuItem)}
                        to={'/profile'}
                        onClick={() => setOpen(false)}
                    >
                        <AccountIcon className={selectStyles.check}/>
                        <div className={selectStyles.content}>Профиль</div>
                    </Link>
                    <div
                        className={clsx(listStyles.item, styles.menuItem)}
                        onClick={() => dispatch(userActions.logout.request())}
                    >
                        <ExitIcon className={selectStyles.check}/>
                        <div className={selectStyles.content}>Выйти</div>
                    </div>
                </div>
            </ShadowContainer>}
        >
            <div>
                <UserPanel
                    className={styles.user}
                    withoutRequest
                    dark
                    user={userData && {
                        ...userData,
                        description: userData.role?.title || userData.description,
                    }}
                    onClick={() => setOpen(!open)}
                    onlyIcon={isMobile}
                >
                    {
                        isDesktop && <ChevronDownIcon className={styles.icon}/>
                    }
                </UserPanel>
            </div>
        </Popover>
    </div>
}

Header.whyDidYouRender = true

export default memo(Header)


